<template>
  <div>
    <div v-if="isBusy" class="loader"></div>
    <p v-if="isBusy" class="text-center">Les données sont en cours de chargement...</p>
    <template v-else>
      <template v-if="comments">
        <div class="feed-activity-list">
          <div v-for="comment in comments" class="feed-element">
            <div :key="comment.id" class="media-body ">
              <small class="float-right">{{ comment.created_at | moment("dddd, DD MMMM YYYY à H:mm") }}</small>
              <strong>{{ comment.user.firstname + " " + comment.user.lastname }}</strong><br>
              <p class="pre-line">{{ comment.comment }}</p>
            </div>
          </div>
        </div>
      </template>
      <p v-else>Il n'y a aucun commentaire pour le moment</p>
      <b-form @submit.prevent="onSubmit">
        <div class="textarea-wrapper">
          <b-form-textarea v-model="new_comment" :required="true" rows="3" max-rows="6" />
        </div>
        <p>* Champs requis</p>
        <div class="form-submit">
          <b-button type="submit" variant="outline-primary" :disabled="inSaving">
            {{ inSaving ? "Enregistrement..." : "Enregistrer" }}
            <i v-if="!inSaving" class="fa fa-chevron-right"></i>
          </b-button>
        </div>
      </b-form>
    </template>
  </div>
</template>

<script>

export default {
  name: "RentingPreparationComments",
  props: ["id_to_edit"],
  data() {
    return {
      new_comment: null,
      isBusy: false,
      inSaving: false,
    };
  },
  computed: {
    comments: function () {
      return this.$store.getters["renting_preparation_comment/getAllByRentingPreparation"](this.id_to_edit) || {};
    }
  },
  watch: {
    id_to_edit: function (id_to_edit) {
      this.isBusy = true;
      this.loadComments()
    }
  },
  methods: {
    loadComments() {
      this.$store
        .dispatch("renting_preparation_comment/getAllByRentingPreparation", {
          wait: true,
          renting_preparation_id: this.id_to_edit,
        })
        .then((response) => {
          this.isBusy = false;
        })
    },
    onSubmit() {
      this.inSaving = true;

      // Validation custom pour les champs datepicker
      let validation = true;
      if (!this.new_comment) {
        this.$toastr.error("Veuillez saisir un commentaire");
        validation = false;
      }
      if (validation !== true) {
        this.inSaving = false;
        return false;
      }

      this.$store
        .dispatch("renting_preparation_comment/addItem",
          {
            renting_preparation_id: this.id_to_edit,
            comment: this.new_comment
          }
        )
        .then((response) => {
          this.new_comment = null
          this.loadComments()
          this.inSaving = false;
        })
        .catch((error) => {
          this.inSaving = false;
        });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/RentingPreparation/RentingPreparationComments.vue